import React from "react";
import type { TEmailBuilderPreviewViewport } from "redux/reducers/emailBuilder/emailBuilder";
import { EmailBuilderCanvasLoadingPlaceholder } from "../EmailBuilderCanvasLoadingPlaceholder";
import {
  EMAIL_BUILDER_PREVIEW_LOADING_MIN_HEIGHT_PX,
  resolveEmailBuilderPreviewFrameMaxWidth,
} from "./emailBuilderPreviewConstants";

interface IEmailBuilderPreviewLoadingFrameProps {
  previewViewport: TEmailBuilderPreviewViewport;
  contentWidthPx: number;
  minHeightPx?: number;
}

export function EmailBuilderPreviewLoadingFrame(props: IEmailBuilderPreviewLoadingFrameProps) {
  const viewportMaxWidth = resolveEmailBuilderPreviewFrameMaxWidth(props.previewViewport);
  const frameWidthPx = viewportMaxWidth ?? props.contentWidthPx;
  const loadingMinHeightPx =
    props.minHeightPx !== undefined && props.minHeightPx > 0
      ? props.minHeightPx
      : EMAIL_BUILDER_PREVIEW_LOADING_MIN_HEIGHT_PX;

  return (
    <div
      className="email-builder-preview-loading-frame"
      style={{ maxWidth: `${frameWidthPx}px` }}
    >
      <EmailBuilderCanvasLoadingPlaceholder
        className="email-builder-preview-loading-frame__placeholder"
        style={
          {
            maxWidth: `${frameWidthPx}px`,
            minHeight: `${loadingMinHeightPx}px`,
            "--email-builder-preview-loading-min-height": `${loadingMinHeightPx}px`,
          } as React.CSSProperties
        }
      />
    </div>
  );
}
